module.exports = __webpack_public_path__ + "img/ActivatorApp.4ae79791.png";